import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody, TableBodyData, TableRow } from 'web-ui-components/lib/molecules/tables';

const PaymentDetailsTable = ({ tableRowMapping }) => (
	<Table isBranded layout="vertical">
		<TableBody>
			{Object.keys(tableRowMapping).map((tableRowKey) => (
				<TableRow key={tableRowKey} id={tableRowKey}>
					<TableBodyData isFeatureCell layout="vertical">
						{tableRowKey}
					</TableBodyData>
					<TableBodyData>{tableRowMapping[tableRowKey]}</TableBodyData>
				</TableRow>
			))}
		</TableBody>
	</Table>
);

PaymentDetailsTable.propTypes = {
	tableRowMapping: PropTypes.shape({}),
};
export default PaymentDetailsTable;
